import React from 'react';
import { annotationShape } from '../../utils/proptypes';

var Annotation = function Annotation(_ref) {
  var data = _ref.data,
      xScale = _ref.xScale,
      height = _ref.height,
      color = _ref.color,
      fillOpacity = _ref.fillOpacity,
      id = _ref.id;
  return React.createElement('rect', {
    key: id,
    className: 'griff-annotation griff-annotation-' + id,
    x: xScale(data[0]),
    y: 0,
    height: height,
    width: xScale(data[1]) - xScale(data[0]),
    style: { stroke: color, fill: color, fillOpacity: fillOpacity }
  });
};

Annotation.propTypes = process.env.NODE_ENV !== "production" ? annotationShape : {};

Annotation.defaultProps = {
  color: '#e8336d',
  fillOpacity: 0.1
};

export default Annotation;